import * as React from "react"

const MOBILE_BREAKPOINT = 768

// Subscribe/getSnapshot for useSyncExternalStore — reads the viewport width
// reactively without a setState-in-effect (which the react-hooks rules flag as
// a cascading-render hazard).
function subscribe(callback: () => void) {
  const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
  mql.addEventListener("change", callback)
  return () => mql.removeEventListener("change", callback)
}

function getSnapshot() {
  return window.innerWidth < MOBILE_BREAKPOINT
}

export function useIsMobile() {
  // Server snapshot is `false` (no viewport); resolves on hydration.
  return React.useSyncExternalStore(subscribe, getSnapshot, () => false)
}
